import React, { useState, useEffect } from "react";
// Chakra imports
import {
  VStack,
  Flex,
  Box,
  Spacer,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  Td,
  useColorModeValue,
  Progress,
  Button,
  useDisclosure,
  Icon
} from "@chakra-ui/react";
import { FaPencilAlt, FaTrashAlt } from "react-icons/fa";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import useGetPersonnels from "../../hooks/useGetPersonnels";
import CreatePersonnel from "../../modals/CreatePersonnel";
import EditPersonnel from "../../modals/EditPersonnel";
import Pagination from "./Pagination";
import { MySearchBar } from "./MySearchBar";



function ToolsClerksTable() { 
  const [ keyword, setKeyword ] = useState("");
    const [ page, setPage ] = useState(1); 
    const pageLimit = 5;
    let { 
      personnels, 
      totalPersonnels,
      setGettingPersonnels, 
      gettingPersonnels, 
      gettingPersonnelsReqSuccess 
    } = useGetPersonnels({ 
      page, 
      limit: pageLimit, 
      keyword: keyword,
      isToolsClerk: true 
    });
    const { isOpen: isOpenCreate, onOpen: onOpenCreate, onClose: onCloseCreate } = useDisclosure();
    const { isOpen: isOpenEdit, onOpen: onOpenEdit, onClose: onCloseEdit } = useDisclosure();
    const [ toEditUser, setToEditUser ] = useState(null);
  
  
    useEffect(() => {
      reloadPage();
    }, [page, keyword]);
  
    useEffect(() => {
      // console.log(personnels);
    }, [personnels]);
  
    const reloadPage = () => {
      setGettingPersonnels(true);
    }
  
    const selectEditItem = (id) => {
      // console.log(id);
      const user = personnels.find((c) => c.id === id);
      // console.log(user.email);
      setToEditUser(user);
      onOpenEdit(true);
    }
  
    const textColor = useColorModeValue("gray.700", "white");

    return (
        <Card overflowX={{ sm: "scroll", xl: "hidden" }}
          mt="24px">

          <CardHeader p="6px 0px 22px 0px">
              <Flex w="100%"
              flexDirection={{
                  sm: "row",
                  md: "row",
              }}
              alignItems={{ xl: "center" }}>
              <Box marginRight={4}>
                  <Text fontSize="lg" color={textColor} fontWeight="bold" pb=".5rem">
                  Tools Clerk
                  </Text>
              </Box>
              <MySearchBar 
                keyword={keyword}
                setKeyword={setKeyword}
                onReload={reloadPage}
              />
              <Spacer />
              <Box>
                  <Button colorScheme="teal" mr="4" onClick={onOpenCreate}>
                  Create New
                  </Button>
              </Box>
              </Flex>
          </CardHeader>
          <CardBody>
              <Flex direction="column" w="100%">
              <Table variant="simple" color={textColor}>
                  <Thead>
                  <Tr my=".8rem" color="gray.400">
                      <Th p={2} color="gray.400">Full Name</Th>
                      <Th p={2} color="gray.400">Email</Th>
                      <Th p={2} color="gray.400">Status</Th>
                      <Th p={2} color="gray.400">Actions</Th>
                  </Tr>
                  </Thead>
                  <Tbody>
                  {gettingPersonnels ? 
                      <Tr my=".8rem" >
                      <Td minWidth={{ sm: "250px" }} pl="0px" colSpan={4}>
                          <Progress isIndeterminate />
                      </Td>
                      </Tr>
                      : personnels.map((user) => {
                      return (
                          <Tr my=".8rem" key={`tools-${user.id}`}>
                          <Td p={2}>{user.firstName + ' ' + user.lastName}</Td>
                          <Td p={2}>{user.email}</Td>
                          <Td p={2}>{user.isDisabled 
                              ? <Text color={'red'}>disabled</Text>
                              : <Text color={'green'}>enabled</Text>}
                          </Td>
                          <Td p={2}>
                              <Button p="0px" bg="transparent" onClick={() => selectEditItem(user.id)}>
                              <Flex color={textColor} cursor="pointer" align="center" p="12px">
                                  <Icon as={FaPencilAlt} me="4px" />
                                  <Text fontSize="xs" fontWeight="semibold">EDIT</Text>
                              </Flex>
                              </Button>
                          </Td>
                          </Tr>
                      );
                      })
                  }
                  </Tbody>
              </Table>
              <Pagination 
                  totalItems={totalPersonnels}
                  pageRows={pageLimit}
                  currentPage={page}
                  onPageChanged={setPage}
              />
              </Flex>


              
          </CardBody>


          <CreatePersonnel 
            isOpen={isOpenCreate}
            onClose={onCloseCreate}
            successCallback={reloadPage} 
            isToolsClerk={true}
          />
      
                    
          <EditPersonnel 
            isOpen={isOpenEdit}
            onClose={() => {
              setToEditUser(null);
              onCloseEdit();
            }}
            successCallback={reloadPage}
            userData={toEditUser}
            isToolsClerk={true}
          />
      </Card>
      );
}


export default ToolsClerksTable;
